/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_AnalyzingInputs */



/**
* | output |
* | --- |
* | "Analyzing audio loudness..." |
*
* @param {Audio_Description_Export_Loudness_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_analyzing = /** @type {((inputs?: Audio_Description_Export_Loudness_AnalyzingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_AnalyzingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse du niveau sonore...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Analyse der Audiolautstärke...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Analisi del volume audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Анализ громкости звука...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Analizando la sonoridad del audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分析音频响度……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオの音量を分析しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो की तीव्रता का विश्लेषण किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Analisando a intensidade sonora...")
	return /** @type {LocalizedString} */ ("Analyzing audio loudness...")
});